import { render } from "./RoleManagement.vue?vue&type=template&id=3481f944&scoped=true"
import script from "./RoleManagement.vue?vue&type=script&lang=js"
export * from "./RoleManagement.vue?vue&type=script&lang=js"

import "./RoleManagement.vue?vue&type=style&index=0&id=3481f944&scoped=true&lang=css"

import exportComponent from "/home/cm/project/golinker/admin-panel/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3481f944"]])

export default __exports__